import { JARGON, KIND } from "../../modules/constants";

const ResultsMessage = searchResults => {
  // console.log("results message: searchResults: ", searchResults)
  const { items, kind, searchString } = searchResults
  const itemsLength = items.length ?? 0

  const typeString = () => {
    if (itemsLength === 1) {
      switch (items[0].kind) {
        case KIND.SEARCH.RESULTS.COMPANY:
          return JARGON.COMPANY

        default:
          return JARGON.OFFICER
      }
    } else { // more than 1 result found
      switch (kind) {
        case KIND.SEARCH.OFFICERS:
        case KIND.SEARCH.DISQUALIFIED:
          return `${JARGON.OFFICER.toLowerCase()}s`

        case KIND.SEARCH.COMPANIES:
        default:
          return JARGON.COMPANIES
      }
    }
  }

  const typeFoundFor = () => `${typeString()} found for "${searchString}"`
  const showingBest = () => `Searched ${typeString()} for "${searchString}"`
  const showingRandom = () => `Showing ${itemsLength} random ${typeString()}`

  const showingAll = () => {
    switch (itemsLength) {
      case undefined:
      case -1: // don't show message if api error
        return
      case 0:
        return `No ${typeFoundFor()}`
      default:
        return `${itemsLength} ${typeFoundFor()}`
    }
  }

  return (searchString === "" || searchResults.searchString !== searchString || !items)
    ? null
    : (itemsLength && searchResults.searchString === "")
      ? showingRandom()
      : (itemsLength > items.length)
        ? showingBest()
        : showingAll()
}

export default ResultsMessage